// Enhanced chart configuration with theme colors and animations
export const getChartOptions = (theme = 'light') => ({
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    duration: 1000,
    easing: 'easeInOutQuart',
  },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        color: '#007E33',
        font: {
          family: 'Inter, system-ui, sans-serif',
          size: 12,
          weight: 500,
        },
        padding: 20,
        usePointStyle: true,
        pointStyle: 'circle',
      },
    },
    tooltip: {
      backgroundColor: 'rgba(0, 168, 132, 0.9)',
      titleColor: '#ffffff',
      bodyColor: '#ffffff',
      borderColor: '#007E33',
      borderWidth: 1,
      cornerRadius: 8,
      titleFont: {
        family: 'Inter, system-ui, sans-serif',
        size: 14,
        weight: 600,
      },
      bodyFont: {
        family: 'Inter, system-ui, sans-serif',
        size: 13,
      },
      padding: 12,
    },
  },
  scales: {
    x: {
      grid: {
        color: '#e9ecef',
        drawBorder: false,
      },
      ticks: {
        color: '#6c757d',
        font: {
          family: 'Inter, system-ui, sans-serif',
          size: 11,
        },
      },
    },
    y: {
      grid: {
        color: '#e9ecef',
        drawBorder: false,
      },
      ticks: {
        color: '#6c757d',
        font: {
          family: 'Inter, system-ui, sans-serif',
          size: 11,
        },
      },
    },
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
});

export const getChartColors = () => ({
  primary: '#00A884',
  secondary: '#007E33',
  success: '#28a745',
  warning: '#ffc107',
  danger: '#dc3545',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
  gradients: {
    primary: ['#00A884', '#007E33'],
    warning: ['#ff6b35', '#f7931e'],
    success: ['#007E33', '#00A884'],
    info: ['#17a2b8', '#138496'],
  },
});

export const createGradient = (ctx, colors, direction = 'vertical') => {
  const gradient = direction === 'vertical' 
    ? ctx.createLinearGradient(0, 0, 0, 400)
    : ctx.createLinearGradient(0, 0, 400, 0);
  
  gradient.addColorStop(0, colors[0]);
  gradient.addColorStop(1, colors[1]);
  return gradient;
};

export const getDatasetConfig = (label, data, colorType = 'primary') => {
  const colors = getChartColors();
  
  return {
    label,
    data,
    backgroundColor: colors.gradients[colorType] ? colors.gradients[colorType][0] + '40' : colors[colorType] + '40',
    borderColor: colors.gradients[colorType] ? colors.gradients[colorType][0] : colors[colorType],
    borderWidth: 2,
    borderRadius: 4,
    borderSkipped: false,
    tension: 0.4,
    fill: true,
    pointBackgroundColor: colors.gradients[colorType] ? colors.gradients[colorType][0] : colors[colorType],
    pointBorderColor: '#ffffff',
    pointBorderWidth: 2,
    pointRadius: 5,
    pointHoverRadius: 7,
    pointHoverBackgroundColor: colors.gradients[colorType] ? colors.gradients[colorType][1] : colors[colorType],
    pointHoverBorderColor: '#ffffff',
    pointHoverBorderWidth: 2,
  };
};